export default {
	one: "一",
	two: "二",
	three: "三",
	four: "四",
	five: "五",
	six: "六",
	seven: "七",
	eight: "八",
	nine: "九",
	ten: "十",
	"index_nihao": "你好，{0}",
	"index_jipiao": "机票",
	"index_jiudianzhusu": "酒店住宿",
	"index_huoche": "火车",
	"index_lvyoudujia": "旅游度假",
	"index_shangwuyonche": "商务用车",
	"index_jinqixingcheng": "近期行程",
	"index_zhi": "至",
	"index_jian": "间",
	"index_qushenpi": "去审批",
	"index_xiangqing": "详情",
	"index_jiantizhongwen": "简体中文",
	"index_jijiangchengxian": "即将呈现!",
	"index_ditugongnengkaifazhong": "地图功能开发中!",
	"index_jiudian": "酒店",
	"index_huochepiao": "火车票",
	"index_yuyan":" 语言",

	"login_qingtianxiemima": "请填写密码",
	"login_wangjimima": "忘记密码",
	"login_qingshuruyanzhengma": "请输入验证码",
	"login_fasongyanzhengma": "发送验证码",
	"login_denglu": "登录",
	"login_yanzhengmadenglu": "验证码登录",
	"login_zhanghaomimadenglu": "账号密码登录",
	"login_jiantizhongwen": "简体中文",
	"login_yingwen": "English",
	"login_riyu": "日本語",
	"login_denglujidaibiaonintongyiwomende": "已阅读并同意我们的",
	"login_tongyi": "同意",
	"login_butongyituichuapp": "不同意并退出APP",
	"login_fuwuxieyi": "《服务协议》",
	"login_fuwuxieyitext": "服务协议",
	"login_he": "和",
	"login_byyzzbbhsyyhdgrysq": "本应用尊重并保护所有用户的个人隐私权。",
	"login_wlgntggzq": "为了给您提供更准确",
	"login_gygxhdfw": "更有个性化的服务",
	"login_keyuedu": "可阅读",
	"login_byyhazyszcdgdsyhplndgrxx": "本应用会按照隐私政策的规定使用和披露您的个人信息。",
	"login_yinsizhengce": "《隐私政策》",
	"login_yinsizhengcetext": "隐私政策",
	"mall_flight_backtorule_fanhui": "返回",
	"mall_flight_backtorule_tuigaiguize": "退改规则",
	"mall_flight_backtorule_goupiaoxuzhi": "购票须知",
	"mall_flight_backtorule_nulihuoquzhong": "努力获取中...",
	"mall_flight_flight_chufadi": "出发地",
	"mall_flight_flight_mudedi": "目的地",
	"mall_flight_flight_chufashijian": "出发时间",
	"mall_flight_flight_fanchengshijian": "返程时间",
	"mall_flight_flight_cangwei": "舱位",
	"mall_flight_flight_tianjialvke": "添加旅客",
	"mall_flight_flight_dianjixuanzelvke": "点击选择旅客",
	"mall_flight_flight_dianjixuanzecangwei": "点击选择舱位",
	"mall_flight_flight_sousuo": "搜索",
	"mall_flight_flight_ruxuyudingertongyingerpiaoqinglianxibengongsikefu": "如需预订儿童/婴儿票，请联系本公司客服。",
	"mall_flight_flight_toudengcang": "头等舱",
	"mall_flight_flight_shangwucang": "商务舱",
	"mall_flight_flight_jingjicang": "经济舱",
	"mall_flight_flight_dancheng": "单 程",
	"mall_flight_flight_wangfan": "往 返",
	"mall_flight_flight_shanghai": "上海",
	"mall_flight_flight_beijing": "北京",
	"mall_flight_flight_guangzhou": "广州",
	"mall_flight_flight_yueri": "MM月DD日",
	"mall_flight_flight_qingxuanzelvke": "请选择旅客",
	"mall_flight_flightchangeinfos_gaiqian": "改签",
	"mall_flight_flightchangeinfos_yuanhangbanxinxi": "原航班信息",
	"mall_flight_flightchangeinfos_di": "第",
	"mall_flight_flightchangeinfos_cheng": "程",
	"mall_flight_flightchangeinfos_yueri": "MM月DD日",
	"mall_flight_flightchangeinfos_tuigaiguize": "退改规则",
	"mall_flight_flightchangeinfos_xinhangbanxinxi": "新航班信息",
	"mall_flight_flightchangeinfos_chuhangrenxinxi": "出行人信息",
	"mall_flight_flightchangeinfos_shouji": "手机：163******42",
	"mall_flight_flightchangeinfos_shenfenzheng": "身份证：3424********0981",
	"mall_flight_flightchangeinfos_tuigaiqianguizejifeiyongbiaozhunshijixuyihangsiweizhun": "退改签规则及费用标准，实际需以航司为准",
	"mall_flight_flightchangeinfos_zongji": "总计：",
	"mall_flight_flightchangeinfos_mingxi": "明细",
	"mall_flight_flightchangeinfos_tijiaoshenhe": "提交审核",
	"mall_flight_flightchangeinfos_woyaogaibianhangchengbuxiangfeiliao": "我要改变行程,不想飞了",
	"mall_flight_flightchangeinfos_jicuohangchengriqishijianxingming": "记错行程、日期、时间、姓名",
	"mall_flight_flightchangeinfos_hangbanyanwuhuoquxiao": "航班延误或取消",
	"mall_flight_flightchangeinfos_genjuguisidechalvbiaozhunqingxuanzegaiqianyuanyin": "根据贵司的差旅标准，请选择改签原因",
	"mall_flight_flightchangeinfos_gongxinintijiaochenggongqingnaixindengdaikefuhejia": "恭喜您，提交成功请耐心等待客服核价",
	"mall_flight_flightchangeinfos_dangqiandingdanbukegaiqianqingninzixundianhuakefuxiexie": "当前订单不可改签,请您咨询电话客服，谢谢！",
	"mall_flight_flightdetails_hangbanxiangqing": "航班详情",
	"mall_flight_flightdetails_zhifei": "直飞",
	"mall_flight_flightdetails_yueri": "MM月DD日",
	"mall_flight_flightdetails_yixiafeiyongjunweichengrenhuoertonghuoyingerderenjunjia": "以下费用均为“1成人或1儿童或1婴儿”的人均价",
	"mall_flight_flightdetails_shangwutuijian": "商务推荐",
	"mall_flight_flightdetails_baoxian": "保险+¥{0}",
	"mall_flight_flightdetails_jinsheng": "仅剩{0}",
	"mall_flight_flightdetails_zhang": "张",
	"mall_flight_flightdetails_tuigaiguize": "退改规则",
	"mall_flight_flightdetails_weibeizhengce": "违背政策",
	"mall_flight_flightdetails_fuhezhengce": "符合政策",
	"mall_flight_flightdetails_ding": "订",
	"mall_flight_flightdetails_tuipiaozhongkai": "退票重开",
	"mall_flight_flightdetails_tuigaishiduan": "退改时段",
	"mall_flight_flightdetails_tuipiaofeiyong": "退票费用",
	"mall_flight_flightdetails_gaiqianfeiyong": "改签费用",
	"mall_flight_flightdetails_qian":"前",
	"mall_flight_flightdetails_ren": "￥{0}/人",
	"mall_flight_flightdetails_hanglie": "行李额",
	"mall_flight_flightdetails_yihangkonggongsizuixinguidingweizhunkezixunkefudianhua": "以航空公司最新规定为准，可咨询客服电话",
	"mall_flight_flightdetails_yscrtgqgzjfybzjgcksj": "以上成人退改签规则及费用标准，仅供参考，实际需以航司为准.",
	"mall_flight_flightdetails_tuigaiguizeyihangsishenheweizhun": "退改规则以航司审核为准",
	"mall_flight_flightdetails_yudingtuijianhangban": "预订推荐低价航班",
	"mall_flight_flightdetails_jixuyudingyuanhangban": "继续预订原航班",
	"mall_flight_flightdetails_gjgsclzctjnyddjhb": "根据公司差旅政策，推荐您预订低价航班",
	"mall_flight_flightdetails_weibei": "违背",
	"mall_flight_flightdetails_qingyihangsishenheweizhun": "请以航司审核为准",
	"mall_flight_flightdetails_gaihangbanweiyinbeiguizebukeyuding": "该航班违因背规则不可预订",
	"mall_flight_flightdetails_nsyddxyjgxytqbàcngsy": "您所预订的协议价格需要提前备案才能够使用，请致电服务热线4000888020，谢谢！",
	"mall_flight_flightdetails_zhe":"{0}折",
	"mall_flight_flightlist_zhongzhuan": "中转",
	"mall_flight_flightlist_jinsheng": "仅剩{0}",
	"mall_flight_flightlist_zhang": "张",
	"mall_flight_flightlist_chongzu": "充足",
	"mall_flight_flightlist_jingting": "经停",
	"mall_flight_flightlist_weibeiguize": "违背规则",
	"mall_flight_flightlist_fuhezhengce": "符合政策",
	"mall_flight_flightlist_jiazaizhong": "加载中...",
	"mall_flight_flightlist_shanghai": "上海",
	"mall_flight_flightlist_beijing": "北京",
	"mall_flight_flightorder_zhifei": "直飞",
	"mall_flight_flightorder_yueri": "MM月DD日",
	"mall_flight_flightorder_piaojia": "票价",
	"mall_flight_flightorder_yuan": "¥{0}元",
	"mall_flight_flightorder_jijianranyou": "机建燃油",
	"mall_flight_flightorder_yuanren": "元/人",
	"mall_flight_flightorder_baoxian": "，保险",
	"mall_flight_flightorder_hangbanxiangqing": "航班详情",
	"mall_flight_flightorder_xuanzechuhangren": "选择出行人",
	"mall_hotel_hotel_ruzhushijian": "入住时间",
	"mall_hotel_hotel_gong": "共",
	"mall_hotel_hotel_wan": "晚",
	"mall_hotel_hotel_lidianshijian": "离店时间",
	"mall_hotel_hotel_guanjianziweizhipinpaijiudianming": "关键字/位置/品牌/酒店名",
	"mall_hotel_hotel_qingshuruguanjianziweizhipinpaijiudianming": "关键字/位置/品牌/酒店名",
	"mall_hotel_hotel_tianjialvke": "添加旅客",
	"mall_hotel_hotel_dianjixuanzelvke": "点击选择旅客",
	"mall_hotel_hotel_sousuo": "搜索",
	"mall_hotel_hotel_dfjqbycgjrzrqbycgwrx": "订房间请不要超过5间，入住日期不要超过20晚。若需特殊预订请联系我司客服。",
	"mall_hotel_hotel_shanghai": "上海",
	"mall_hotel_hotel_yueri": "MM月DD日",
	"mall_hotel_hotel_qingxuanzelvke": "请选择旅客",
	"mall_hotel_hotel_lvkeshuliangshangxianqinglianxikefu": "旅客数量上限,请联系客服",
	"mall_hotel_hotel_wenxintishi": "温馨提示",
	"mall_hotel_hotel_zxydcgwfyknbzjylxkfh": "在线预订超过20晚,房源可能不足建议联系客服获取更多房源方案",
	"mall_hotel_hotel_jixuyuding": "继续预订",
	"mall_hotel_hotel_lianxikefu": "联系客服",
	"mall_hotel_hoteldetails_fanhui": "返回",
	"mall_hotel_hoteldetails_pingfen": "评分",
	"mall_hotel_hoteldetails_fen": "分",
	"mall_hotel_hoteldetails_zanwupingfen": "暂无评分",
	"mall_hotel_hoteldetails_xingji": "{0}星级",
	"mall_hotel_hoteldetails_tingchechang": "停车场",
	"mall_hotel_hoteldetails_jianshenfang": "健身房",
	"mall_hotel_hoteldetails_hanglijicun": "行李寄存",
	"mall_hotel_hoteldetails_dizhi": "地址:{0}",
	"mall_hotel_hoteldetails_dianhua": "电话:{0}",
	"mall_hotel_hoteldetails_yueri": "M月DD日",
	"mall_hotel_hoteldetails_ruzhu": "入住",
	"mall_hotel_hoteldetails_lidian": "离店",
	"mall_hotel_hoteldetails_wan": "晚",
	"mall_hotel_hoteldetails_jianren": "1间{0}人",
	"mall_hotel_hoteldetails_qi": "￥{0}起",
	"mall_hotel_hoteldetails_zao": "早",
	"mall_hotel_hoteldetails_kezhu": "可住",
	"mall_hotel_hoteldetails_ren": "人",
	"mall_hotel_hoteldetails_bukequxiao": "不可取消",
	"mall_hotel_hoteldetails_fuhezhengce": "符合政策",
	"mall_hotel_hoteldetails_weibeizhengce": "违背政策",
	"mall_hotel_hoteldetails_yuding": "订",
	"mall_hotel_hoteldetails_gaijiudianzanwuheshifangjian": "该酒店暂无合适房间！",
	"mall_hotel_hoteldetails_xieyijiudian": "协议酒店",
	"mall_hotel_hoteldetails_wu": "无",
	"mall_hotel_hoteldetails_dan": "单",
	"mall_hotel_hoteldetails_shuang": "双",
	"mall_hotel_hoteldetails_duo": "多",
	"mall_hotel_hoteldetails_weibei": "违背",
	"mall_hotel_hoteldetails_gaifangjianyinweibeiguizebukeyuding": "该房间因违背规则不可预订",
	"mall_hotel_hoteldetails_wenxintishi": "温馨提示",
	"mall_hotel_hoteldetails_bjdwxyjdknczfxqnzxbh": "本酒店为协议酒店，可能存在风险，请您知晓并合理安排出行，谢谢！",
	"mall_hotel_hotellist_meiyougengduoliao": "没有更多了",
	"mall_hotel_hotellist_qi": "￥{0}起",
	"mall_hotel_hotellist_fen": "分",
	"mall_hotel_hotellist_weibeiguize": "违背规则",
	"mall_hotel_hotellist_fuhezhengce": "符合政策",
	"mall_hotel_hotellist_jiazaizhong": "加载中...",
	"mall_hotel_hotellist_xieyijiudian": "协议酒店",
	"mall_hotel_hotelorder_ruzhu": "入住:",
	"mall_hotel_hotelorder_wan": "晚",
	"mall_hotel_hotelorder_lidian": "离店:",
	"mall_hotel_hotelorder_jian": "/间",
	"mall_hotel_hotelorder_dingdanquerenhoubukequxiao": "订单确认后不可取消",
	"mall_hotel_hotelorder_tuigaixiangqing": "退改详情",
	"mall_hotel_hotelorder_ruzhuxinxi": "入住信息",
	"mall_hotel_hotelorder_dingdantianxie": "订单填写",
	"mall_hotel_hotelorder_yueri": "M月DD日",
	"mall_modules_addpassengers_fanhui": "返回",
	"mall_modules_addpassengers_tianjiachengke": "添加乘客",
	"mall_modules_addpassengers_wancheng": "完成",
	"mall_modules_addpassengers_qingshurulvkemingchengpipeihuotianjiaweilinke": "请输入旅客名称匹配或添加为临客",
	"mall_modules_addpassengers_tianjia": "+ 添加",
	"mall_modules_addpassengers_wei": "为",
	"mall_modules_addpassengers_linke": "临客",
	"mall_modules_addpassengers_shanchu": "删除",
	"mall_modules_addpassengers_qingjianglinkemingchengshurudaosousuokuangneihouzhongshi": "请将临客名称输入到搜索框内后重试",
	"mall_modules_change_gaiqian": "改签",
	"mall_modules_change_gaiqianyuanyin": "改签原因",
	"mall_modules_change_tuigaiqianguizejifeiyongbiaozhunshijixuyihangsiweizhun": "退改签规则及费用标准，实际需以航司为准",
	"mall_modules_change_xiayibuqingxuanzegaiqianriqi": "下一步,请选择改签日期",
	"mall_modules_change_tuigaiguize": "退改规则",
	"mall_modules_change_woyaogaibianhangchengbuxiangfeiliao": "我要改变行程,不想飞了",
	"mall_modules_change_jicuohangchengriqishijianxingming": "记错行程、日期、时间、姓名",
	"mall_modules_change_hangbanyanwuhuoquxiao": "航班延误或取消",
	"mall_modules_change_genjuguisidechalvbiaozhunqingxuanzegaiqianyuanyin": "根据贵司的差旅标准，请选择改签原因",
	"mall_modules_change_qingxuanzexuyaogaiqiandelvcheng": "请选择需要改签的旅程",
	"mall_modules_change_qingxuanzelvke": "请选择旅客",
	"mall_modules_change_shanghai": "上海",
	"mall_modules_change_beijing": "北京",
	"mall_modules_change_gaichecimeiyoupipeituigaiguize": "该车次没有匹配退改规则",
	"mall_modules_choosecontraryreason_weibeiyuanyin": "违背原因",
	"mall_modules_choosecontraryreason_qingshuruliyoumingcheng": "请输入理由名称",
	"mall_modules_choosecostcenter_chengbenzhongxin": "成本中心",
	"mall_modules_chooseprojectcode_qingshuruxiangmudaima": "请输入项目代码",
	"mall_modules_chooseprojectcode_tianjia": "添加",
	"mall_modules_chooseprojectcode_weixiangmudaima": "为项目代码",
	"mall_modules_choosetripintent_chalvmude": "差旅目的",
	"mall_modules_choosetripintent_qingshuruchalvmude": "请输入差旅目的",
	"mall_modules_editrole_fanhui": "返回",
	"mall_modules_editrole_tianjialinke": "添加临客",
	"mall_modules_editrole_xingpinyin": "姓(拼音)",
	"mall_modules_editrole_mingpinyin": "名(拼音)",
	"mall_modules_editrole_zhongwenxingming": "中文姓名",
	"mall_modules_editrole_qingshuruxingming": "请输入姓名",
	"mall_modules_editrole_zhengjianleixing": "证件类型",
	"mall_modules_editrole_dianjixuanzezhengjianleixing": "点击选择证件类型",
	"mall_modules_editrole_xingbie": "性别",
	"mall_modules_editrole_dianjixuanzexingbie": "点击选择性别",
	"mall_modules_editrole_guoji": "国籍",
	"mall_modules_editrole_dianjixuanzeguoji": "点击选择国籍",
	"mall_modules_editrole_zhengjianhaoma": "证件号码",
	"mall_modules_editrole_qingshuruzhengjianhaoma": "请输入证件号码",
	"mall_modules_editrole_chushengriqi": "出生日期",
	"mall_modules_editrole_dianjixuanzechushengriqi": "点击选择出生日期",
	"mall_modules_editrole_shoujihaoma": "手机号码",
	"mall_modules_editrole_qingshurushoujihaoma": "请输入手机号码",
	"mall_modules_editrole_youxiang": "邮箱",
	"mall_modules_editrole_qingtianxieyouxianghaoma": "请填写邮箱号码",
	"mall_modules_editrole_sfbcwck": "是否保存为常客",
	"mall_modules_editrole_baocun": "保存",
	"mall_modules_editrole_lichenggongsi": "力程公司",
	"mall_modules_editrole_nan": "男",
	"mall_modules_editrole_nv": "女",
	"mall_modules_editrole_zhongguo": "中国",
	"mall_modules_frequentercardfill_fanhui": "返回",
	"mall_modules_frequentercardfill_tianxiechangkelvkeqia": "填写常客旅客卡",
	"mall_modules_frequentercardfill_zhangsan": "张三",
	"mall_modules_frequentercardfill_qingxuanzehangkonggongsi": "请选择航空公司",
	"mall_modules_frequentercardfill_qingtianxiechanglvkeqiahao": "请填写常旅客卡号",
	"mall_modules_frequentercardfill_wancheng": "完成",
	"mall_modules_frequentercardfill_dongfanghangkong": "东方航空",
	"mall_modules_frequentercardfill_zhongguohangkong": "中国航空",
	"mall_modules_frequentercardfill_nanfanghangkong": "南方航空",
	"mall_modules_productdetails_fanhui": "返回",
	"mall_modules_producthome_chalvguizemingcheng": "差旅规则名称：",
	"mall_modules_producthome_guoji": "国际",
	"mall_modules_producthome_guonei": "国内",
	"mall_modules_producthome_jipiaofuwu": "机票服务",
	"mall_modules_producthome_jiudianfuwu": "酒店服务",
	"mall_modules_producthome_huochefuwu": "火车服务",
	"mall_modules_producthome_zuidijiagejizhun": "最低价格基准：",
	"mall_modules_producthome_shishihangbanguankong": "实时航班管控：",
	"mall_modules_producthome_tiqianyudingshijian": "提前预订时间：",
	"mall_modules_producthome_cangweijibiexianzhi": "舱位级别限制：",
	"mall_modules_producthome_zuoweijibiexianzhi": "座位级别限制：",
	"mall_modules_producthome_xieyijipiaoyouxian": "协议机票优先：",
	"mall_modules_producthome_xieyijiudianyouxian": "协议酒店优先：",
	"mall_modules_producthome_xiaofeijineshangxian": "消费金额上限：",
	"mall_modules_producthome_shenpimingcheng": "审批名称：",
	"mall_modules_producthome_toudengcang": "头等舱",
	"mall_modules_producthome_shangwucang": "商务舱",
	"mall_modules_producthome_jingjicang": "经济舱",
	"mall_modules_producthome_jingjicang5zhe": "经济舱(5折)",
	"mall_modules_producthome_jingjicang6zhe": "经济舱(6折)",
	"mall_modules_producthome_jingjicang7zhe": "经济舱(7折)",
	"mall_modules_producthome_jingjicang8zhe": "经济舱(8折)",
	"mall_modules_producthome_jingjicang9zhe": "经济舱(9折)",
	"mall_modules_producthome_yinei": "以内",
	"mall_modules_producthome_bufenhangxian": "部分航线",
	"mall_modules_producthome_bufenjiudian": "部分酒店",
	"mall_modules_producthome_jichengshiyinei": "{0}级城市{1}以内",
	"mall_modules_productlist_fanhui": "返回",
	"mall_modules_productlist_tuigaiguize": "退改规则",
	"mall_modules_productlist_zhu": "住",
	"mall_modules_productlist_li": "离",
	"mall_modules_productlist_guanjianziweizhijiudianmingpinpai": "关键字/位置/酒店名/品牌",
	"mall_modules_productlist_qianyitian": "前一天",
	"mall_modules_productlist_houyitian": "后一天",
	"mall_modules_productlist_weizhijuli": "位置距离",
	"mall_modules_productlist_jiagexingji": "价格/星级",
	"mall_modules_productlist_shaixuan": "筛选",
	"mall_modules_productlist_queren": "确认",
	"mall_modules_productlist_gengduoshaixuan": "更多筛选",
	"mall_modules_productlist_chalvguizemingcheng": "差旅规则名称：",
	"mall_modules_productlist_zuidijiagejizhun": "最低价格基准：",
	"mall_modules_productlist_shishihangbanguankong": "实时航班管控：",
	"mall_modules_productlist_tiqianyudingshijian": "提前预订时间：",
	"mall_modules_productlist_cangweijibiexianzhi": "舱位级别限制：",
	"mall_modules_productlist_zuoweijibiexianzhi": "座位级别限制：",
	"mall_modules_productlist_xieyijipiaoyouxian": "协议机票优先：",
	"mall_modules_productlist_xieyijiudianyouxian": "协议酒店优先：",
	"mall_modules_productlist_xiaofeijineshangxian": "消费金额上限：",
	"mall_modules_productlist_shenpimingcheng": "审批名称：",
	"mall_modules_productlist_toudengcang": "头等舱",
	"mall_modules_productlist_shangwucang": "商务舱",
	"mall_modules_productlist_jingjicang": "经济舱",
	"mall_modules_productlist_jingjicangzhe": "经济舱(5折)",
	"mall_modules_productlist_hangzhengqu": "行政区",
	"mall_modules_productlist_buxian": "不限",
	"mall_modules_productlist_shangyequ": "商业区",
	"mall_modules_productlist_jiage": "价格",
	"mall_modules_productlist_yixia": "¥ 150以下",
	"mall_modules_productlist_yishang": "¥ 600以上",
	"mall_modules_productlist_xingji": "星级",
	"mall_modules_productlist_erxingjijiyixia": "二星级及以下",
	"mall_modules_productlist_sanxingjishushi": "三星级/舒适",
	"mall_modules_productlist_sixingjigaodang": "四星级/高档",
	"mall_modules_productlist_wuxingjihaohua": "五星级/豪华",
	"mall_modules_productlist_tese": "特色",
	"mall_modules_productlist_fuwu": "服务",
	"mall_modules_productlist_chexingxuanze": "车型选择",
	"mall_modules_productlist_gaotie": "高铁(G/C)",
	"mall_modules_productlist_dongche": "动车(D)",
	"mall_modules_productlist_putong": "普通(Z/T/K)",
	"mall_modules_productlist_qitadeng": "其他(L/Y等)",
	"mall_modules_productlist_qita": "其他",
	"mall_modules_productlist_facheshijian": "发车时间",
	"mall_modules_productlist_chalvzhengce": "差旅政策",
	"mall_modules_productlist_fuhezhengce": "符合政策",
	"mall_modules_productlist_weibeiguize": "违背规则",
	"mall_modules_productlist_zhongzhuanzhifei": "直飞/中转",
	"mall_modules_productlist_jinkanzhongzhuan": "仅看中转",
	"mall_modules_productlist_jinkanzhifei": "仅看直飞",
	"mall_modules_productlist_chufachezhan": "出发车站",
	"mall_modules_productlist_daodachezhan": "到达车站",
	"mall_modules_productlist_zhinengpaixu": "智能排序",
	"mall_modules_productlist_morenpaixu": "默认排序",
	"mall_modules_productlist_dijiayouxian": "低价优先",
	"mall_modules_productlist_gaojiayouxian": "高价优先",
	"mall_modules_productlist_xingjiyouxian": "星级优先",
	"mall_modules_productlist_putongyouxian": "普通优先",
	"mall_modules_productlist_shijianpaixu": "时间排序",
	"mall_modules_productlist_congzaodaowan": "从早到晚",
	"mall_modules_productlist_congwandaozao": "从晚到早",
	"mall_modules_productlist_jiagepaixu": "价格排序",
	"mall_modules_productlist_congdidaogao": "从低到高",
	"mall_modules_productlist_conggaodaodi": "从高到低",
	"mall_modules_productlist_qifeishijian": "起飞时间",
	"mall_modules_productlist_qifeijichang": "起飞机场",
	"mall_modules_productlist_daodajichang": "到达机场",
	"mall_modules_productlist_cangwei": "舱位",
	"mall_modules_productlist_hangkonggongsi": "航空公司",
	"mall_modules_productlist_yinei": "以内",
	"mall_modules_productlist_bufenhangxian": "部分航线",
	"mall_modules_productlist_bufenjiudian": "部分酒店",
	"mall_modules_productlist_jichengshiyinei": "{0}级城市{1}以内",
	"mall_modules_addkeywords_guanjianziweizhijiudianmingpinpai": "关键字/位置/酒店名/品牌",
	"mall_modules_addkeywords_qsrhxggjzwzppjdmckssjg": "请输入或修改关键字/位置/品牌/酒店名 查看搜索结果",
	"mall_modules_refund_tuidingyuanyin": "退订原因",
	"mall_modules_refund_tuigaiqianguizejifeiyongbiaozhunshijixuyihangsiweizhun": "退改签规则及费用标准，实际需以航司为准",
	"mall_modules_refund_zongji": "总计：",
	"mall_modules_refund_yujituipiaofei": "预计退票费：",
	"mall_modules_refund_mingxi": "明细",
	"mall_modules_refund_tijiaoshenhe": "提交审核",
	"mall_modules_refund_hangchengbiangeng": "行程变更",
	"mall_modules_refund_hangchengquxiao": "行程取消",
	"mall_modules_refund_woyaogaibianhangchengbuxiangfeiliao": "我要改变行程,不想飞了",
	"mall_modules_refund_jicuohangchengriqishijianxingming": "记错行程、日期、时间、姓名",
	"mall_modules_refund_hangbanyanwuhuoquxiao": "航班延误或取消",
	"mall_modules_refund_genjuguisidechalvbiaozhunqingxuanzetuidingyuanyin": "根据贵司的差旅标准，请选择退订原因",
	"mall_modules_refund_shenqingtuipiao": "申请退票",
	"mall_modules_refund_shenqingtuifang": "申请退房",
	"mall_modules_refund_qingxuanzexuyaotuidingdelvcheng": "请选择需要退订的旅程",
	"mall_modules_refund_qingxuanzelvke": "请选择旅客",
	"mall_modules_refund_qingxuanzetuidingyuanyin": "请选择退订原因",
	"mall_modules_refund_tuipiaoshenqingtijiaochenggong": "退票申请提交成功",
	"mall_modules_remarks_xuqiubeizhu": "需求备注",
	"mall_modules_remarks_baocun": "保存",
	"mall_modules_remarks_ndtsxqwmhjlxtrwfmzwm": "您的特殊需求，我们会尽量协调。如无法满足，我们不会另行通知，请您见谅",
	"mall_order_shifa": "始发",
	"mall_order_jingting": "经停",
	"mall_order_yueri": "MM月DD日 ddd",
	"mall_order_tuigaixuzhi": "退改须知",
	"mall_order_fangjianshu": "房间数",
	"mall_order_jian": "间",
	"mall_order_rfjcgwjsklxkfhcfyd": "若房间超过5间时，可联系客服或拆分预订！",
	"mall_order_meijianzuiduokezhu": "每间最多可住",
	"mall_order_ren": "人",
	"mall_order_zuoxixuanze": "座席选择",
	"mall_order_chuang": "窗",
	"mall_order_guodao": "过道",
	"mall_order_wbzndslcxqwbbztxxycysczjyz":"为了您顺利出行，请务必保证填写项与出游所持证件一致",
	"mall_order_fasongduanxin": "发送短信",
	"mall_order_baoxianxinxi": "保险信息",
	"mall_order_yqqjjqfhslrsbxdzfwyf": "疫情期间加强防护，商旅人士保险定制服务，一份保障，全家安心",

	"mall_order_shanglvxinxi": "商旅信息",
	"mall_order_shenpipingzheng": "审批凭证",
	"mall_order_youshenpipingzheng": "有审批凭证",
	"mall_order_wushenpipingzheng": "无审批凭证",
	"mall_order_shenpizhuangtai": "审批状态",
	"mall_order_chuchaishenqingiworkyishenpi": "出差申请Iworker已审批",
	"mall_order_shangweishenpi": "尚未审批",
	"mall_order_yijishenpi": "级审批",
	
	"mall_order_shenpidanhao": "审批单号",
	"mall_order_liuchenglingdaochuchabaogaodanhao": "IMIS流程领导出差报告单号",
	"mall_order_chengbenzhongxin": "成本中心",
	"mall_order_qingxuanzechengbenzhongxin": "请选择成本中心",
	"mall_order_chalvmude": "差旅目的",
	"mall_order_qingxuanzechalvmude": "请选择差旅目的",
	"mall_order_mudexiangqing": "目的详情",
	"mall_order_chalvmudebumingquexubuchongxiangxichalvmude": "出差事由",
	"mall_order_xiangmudaima": "项目代码",
	"mall_order_qingxuanzexiangmudaima": "请选择项目代码",
	"mall_order_weibeiyuanyin": "违背原因",
	"mall_order_yusuanbianma": "预算编码",
	"mall_order_fujianxinxi": "附件信息",
	"mall_order_yusuanmiaoshu": "预算描述",
	"mall_order_xingchengweibeile": "行程违背了",
	'mall_order_dezhengce': "的政策",
	"mall_order_qingxuanzeweibeiyuanyin": "请选择违背原因",
	"mall_order_xiangxiyuanyin": "详细原因",
	"mall_order_shenpiren": "审批人",
	"mall_order_qingxuanzeshenpiren": "请选审批人",
	"mall_order_lianxirenxinxi": "联系人信息",
	"mall_order_xingming": "姓名",
	"mall_order_qingshuruyonghuming": "请输入用户名",
	"mall_order_shouji": "手机",
	"mall_order_qingshurushoujihao": "请输入手机号",
	"mall_order_youxiang": "邮箱",
	"mall_order_qingshuruyouxiang": "请输入邮箱",
	"mall_order_xuqiubeizhu": "需求备注",
	"mall_order_koukuanshuoming": "扣款说明:",
	"mall_order_hgjndfkfsjhysqhkcffr": "会根据您的付款方式进行预授权或扣除房费，如订单不确认 将解除预授权或全额退款至您的付款账户。该订单确认后不 可被取消修改，若未入住将收取您首日房费，如提前离店将 扣除提前离店当天的费用。",
	"mall_order_tebietishi": "特别提示:",
	"mall_order_gjddrzsjwtfbzjssjwrt": "该酒店的入住时间为14:00，退房标准结算时间为12:00。如 提前入住或推迟离店，均须酌情加收一定的费用。",
	"mall_order_mingxi": "明细",
	"mall_order_tijiaozhifu": "提交/支付",
	"mall_order_feiyongmingxi": "费用明细",
	"mall_order_baoxianfei": "保险费",
	"mall_order_fuwufei": "服务费",
	"mall_order_zonge": "总额",
	"mall_order_dingdanzhengzaishengcheng": "订单正在生成...",
	"mall_order_nulizhanzuozhong": "努力占座中...",
	"mall_order_tuipiaoshuoming": "退票说明",
	"mall_order_dgcgwqpqfcqsjdyfzkjr": "1、代购成功，未取票且发车前时间大于35分钟，可进入“我的订单”，点击火车订单根据提示申请退票；发车前8天以内的退票，铁路局将对每张车票按梯次收取退票手续费。",
	"mall_order_dgcgyqphfcqsjxyfzxnz": "2、代购成功，已取票或发车前时间小于35分钟，需您自行携带购票时所使用的乘车人有效证件原件和火车票在发车前去火车站退票窗口办理退票。",
	"mall_order_gaiqianshuoming": "改签说明",
	"mall_order_wqzzpqlfcsjdyfzkgqdy": "1、未取纸质票，且离发车时间大于35分钟，可改签等于或低于原车票票价的车次。其他不能在线改签的情况需在发车前至火车站窗口办理。",
	"mall_order_kcqxsyskgqysqndcckcq": "2、开车前48小时以上，可改签预售期内的车次。开车前48小时以内，可改签至票面当天24：00之前任意车次，不办理票面日期次日及以后的改签",
	"mall_order_xcppjdyycpdthcédcébf": "3、新车票票价低于原车票的，退还差额，对差额部分核收退票费并执行现行退票费标准。",
	"mall_order_querendingdan": "确认订单",
	"mall_order_xuanzechuhangren": "选择出行人",
	"mall_order_lichenggongsi": "力程公司",
	"mall_order_yi": "一",
	"mall_order_er": "二",
	"mall_order_san": "三",
	"mall_order_yueri1": "MM月DD日",
	"mall_order_qingtianxiexiangmudaima": "请填写项目代码",
	"mall_order_qingtianxieshenpidanhao": "请填写审批单号",
	"mall_order_qingtianxiechalvmude": "请填写差旅目的",
	"mall_order_qingtianxiexiangqingmude": "请填写详情目的",
	"mall_order_qingtianxieweibeixiangqingyuanyin": "请填写违背详情原因",
	"mall_order_ghbjpwzhxscpnxxzyzbx": "该航班机票为组合销售产品,您需选择一种保险产品。或者请您另选其它航班机票",
	"mall_order_gcczxwzhxscpnxxzyzbx": "该车次座席为组合销售产品,您需选择一种保险产品。或者请您另选其它车次",
	"mall_order_qingtianxielvkezhengjianhaoma": "请填写旅客证件号码",
	"mall_order_wenxintishi": "温馨提示!",
	"mall_order_shifoujixuyuding": "{0}是否继续预订",
	"mall_order_ddcjcghynsszddxxzgzd": "订单创建成功，欢迎您随时在订单详细中关注订单进度",
	"mall_order_hejiazhong": "核价中...",
	"mall_order_fangjianshubukedayuruzhurenshu": "房间数不可大于入住人数",
	"mall_train_train_chufadi": "出发地",
	"mall_train_train_mudedi": "目的地",
	"mall_train_train_chufashijian": "出发时间",
	"mall_train_train_zuoxi": "坐席",
	"mall_train_train_yidengzuo": "一等座",
	"mall_train_train_tianjialvke": "添加旅客",
	"mall_train_train_dianjixuanzelvke": "点击选择旅客",
	"mall_train_train_sousuo": "搜索",
	"mall_train_train_dangqianshiduanbutigongchecichaxunfuwu": "当前时段不提供车次查询服务",
	"mall_train_train_tsgpsjwzwgpgqhtpxbwy": "提示：购票时间为早5:30—晚00:30。购票、改签和退票须不晚于开车前30分钟。当天内行程请在10分钟内支付，24小时以外行程请在25分钟内支付。",
	"mall_train_train_shanghai": "上海",
	"mall_train_train_beijing": "北京",
	"mall_train_train_yueri": "MM月DD日",
	"mall_train_train_qingxuanzelvke": "请选择旅客",
	"mall_train_trainchangeinfos_gaiqian": "改签",
	"mall_train_trainchangeinfos_yuanchecixinxi": "原车次信息",
	"mall_train_trainchangeinfos_di": "第{0}",
	"mall_train_trainchangeinfos_cheng": "程",
	"mall_train_trainchangeinfos_yueri": "MM月DD日",
	"mall_train_trainchangeinfos_tuigaiguize": "退改规则",
	"mall_train_trainchangeinfos_xinchecixinxi": "新车次信息",
	"mall_train_trainchangeinfos_chuhangrenxinxi": "出行人信息",
	"mall_train_trainchangeinfos_shouji": "手机：163******42",
	"mall_train_trainchangeinfos_shenfenzheng": "身份证：3424********0981",
	"mall_train_trainchangeinfos_tuigaiqianguizejifeiyongbiaozhunshijixuyishijishenheweizhun": "退改签规则及费用标准，实际需以实际审核为准",
	"mall_train_trainchangeinfos_zongji": "总计：",
	"mall_train_trainchangeinfos_mingxi": "明细",
	"mall_train_trainchangeinfos_tijiaoshenhe": "提交审核",
	"mall_train_trainchangeinfos_woyaogaibianhangchengbuxiangfeiliao": "我要改变行程,不想飞了",
	"mall_train_trainchangeinfos_jicuohangchengriqishijianxingming": "记错行程、日期、时间、姓名",
	"mall_train_trainchangeinfos_hangbanyanwuhuoquxiao": "航班延误或取消",
	"mall_train_trainchangeinfos_genjuguisidechalvbiaozhunqingxuanzegaiqianyuanyin": "根据贵司的差旅标准，请选择改签原因",
	"mall_train_trainchangeinfos_gaiqianchenggongqingninguanzhudingdanzhuangtai": "改签成功,请您关注订单状态！",
	"mall_train_trainchangeinfos_dangqiandingdanbukegaiqianqingninzixundianhuakefuxiexie": "当前订单不可改签,请您咨询电话客服，谢谢！",
	"mall_train_traindetails_checixiangqing": "车次详情",
	"mall_train_traindetails_tuigaiguize": "退改规则",
	"mall_train_traindetails_shifa": "始发",
	"mall_train_traindetails_weibeizhengce": "违背政策",
	"mall_train_traindetails_fuhezhengce": "符合政策",
	"mall_train_traindetails_youpiao": "有票",
	"mall_train_traindetails_wupiao": "无票",
	"mall_train_traindetails_jinsheng": "仅剩",
	"mall_train_traindetails_zhang": "张",
	"mall_train_traindetails_ding": "预订",
	"mall_train_traindetails_tuipiaoshuoming": "退票说明",
	"mall_train_traindetails_dgcgwqpqfcqsjdyfzkjr": "1、代购成功，未取票且发车前时间大于35分钟，可进入“我的订单”，点击火车订单根据提示申请退票；发车前8天以内的退票，铁路局将对每张车票按梯次收取退票手续费。",
	"mall_train_traindetails_dgcgyqphfcqsjxyfzxnz": "2、代购成功，已取票或发车前时间小于35分钟，需您自行携带购票时所使用的乘车人有效证件原件和火车票在发车前去火车站退票窗口办理退票。",
	"mall_train_traindetails_gaiqianshuoming": "改签说明",
	"mall_train_traindetails_wqzzpqlfcsjdyfzkgqdy": "1、未取纸质票，且离发车时间大于35分钟，可改签等于或低于原车票票价的车次。其他不能在线改签的情况需在发车前至火车站窗口办理。",
	"mall_train_traindetails_kcqxsyskgqysqndcckcq": "2、开车前48小时以上，可改签预售期内的车次。开车前48小时以内，可改签至票面当天24：00之前任意车次，不办理票面日期次日及以后的改签",
	"mall_train_traindetails_xcppjdyycpdthcédcébf": "3、新车票票价低于原车票的，退还差额，对差额部分核收退票费并执行现行退票费标准。",
	"mall_train_traindetails_weibei": "违背",
	"mall_train_trainlist_weibeiguize": "违背规则",
	"mall_train_trainlist_fuhezhengce": "符合政策",
	"mall_train_trainlist_shouqi": "收起",
	"mall_train_trainlist_zhankai": "展开",
	"mall_train_trainlist_you": "有",
	"mall_train_trainlist_zhang": "张",
	"mall_train_trainlist_wu": "无",
	"mall_train_trainlist_zhanxu": "站序",
	"mall_train_trainlist_zhanming": "站名",
	"mall_train_trainlist_daoshi": "到时",
	"mall_train_trainlist_fashi": "发时",
	"mall_train_trainlist_tingliu": "停留",
	"mall_train_trainlist_jiazaizhong": "加载中...",
	"mall_train_trainlist_xiuxizhongmingtianzailai": "休息中,明天再来...",
	"mall_train_trainlist_dqcczxwypqnlxqtcchlā": "当前车次座席无余票!请您另选其他车次,合理安排出行,谢谢!",
	"mall_train_trainlist_qita": "其他",
	"mall_train_trainorder_zhifei": "直飞",
	"mall_train_trainorder_yueri": "MM月DD日",
	"mall_train_trainorder_piaojia": "票价",
	"mall_train_trainorder_yuan": "元(",
	"mall_train_trainorder_jijianranyou": "机建燃油{{ totalPrices(",
	"mall_train_trainorder_yuanrenbaoxianyuanren": "元/人，保险20元/人",
	"mall_train_trainorder_checixiangqing": "车次详情",
	"modules_selectcity_qingshuruchengshimingcheng": "请输入城市名称",
	"modules_selectcity_guoji": "国际",
	"modules_selectcity_guonei": "国内",
	"modules_selectcity_diqu": "地区",
	"modules_selectcity_chezhan": "车站",
	"modules_selectcity_remen": "热门",
	"modules_webmap_dingwei": "定位",
	"modules_webmap_wodebeizhu": "我的备注",
	"modules_webmap_wodebiaoji": "我的标记",
	"order_flight_flightdetail_di": "第",
	"order_flight_flightdetail_yi": "一",
	"order_flight_flightdetail_er": "二",
	"order_flight_flightdetail_cheng": "程",
	"order_flight_flightdetail_yueri": "MM月DD日",
	"order_flight_flightdetail_tuigaiguize": "退改规则",
	"order_flight_flightorderinfo_dancheng": "(单程)",
	"order_flight_flightorderinfo_weibeizhengce": "违背政策",
	"order_flight_flightorderinfo_gongxiang": "共享",
	"order_flight_flightorderinfo_nianyueri": "YYYY年M月DD日 ddd",
	"order_flight_flightorderinfo_tuigaiguize": "退改规则",
	"order_flight_flightorderinfo_yiquxiao": "已取消",
	"order_flight_flightorderinfo_weibeizhengceyuanyin": "违背原因：{0}",
	"order_flight_flightorderinfo_weibeixiangqing": "违背详情：",
	"order_flight_flightorderinfo_quchuli": "去处理",
	"order_flight_flightorderinfo_details": "详情",
	"order_flight_flightorderinfo_fuhezhengcedingdanshenpi": "符合政策订单审批",
	"order_flight_flightorderinfo_mingxi": "明细",
	"order_flight_flightorderinfo_gaiqian": "改签",
	"order_flight_flightorderinfo_tuipiao": "退票",
	"order_flight_flightorderinfo_quxiaotuipiao": "取消退票",
	"order_flight_flightorderinfo_quxiaogaiqian": "取消改签",
	"order_flight_flightorderinfo_quxiaodingdan": "取消订单",
	"order_flight_flightorderinfo_shenpi": "审批",
	"order_flight_flightorderinfo_shenqingren": "申请人：{0}",
	"order_flight_flightorderinfo_gaiqianren": "改签人：{0}",
	"order_flight_flightorderinfo_gaiqianyuanyin": "改签原因：{0}",
	"order_flight_flightorderinfo_xiangqingyuanyin": "详情原因：{0}",
	"order_flight_flightorderinfo_jiazaizhong": "加载中...",
	"order_flight_flightorderinfo_yunxutuipiao": "允许退票",
	"order_flight_flightorderinfo_jujuetuipiao": "拒绝退票",
	"order_flight_flightorderinfo_yunxugaiqian": "允许改签",
	"order_flight_flightorderinfo_jujuegaiqian": "拒绝改签",
	"order_flight_flightorderinfo_shenpitongguo": "审批通过",
	"order_flight_flightorderinfo_shenpijujue": "审批拒绝",
	"order_hotel_hoteldetail_wan": "晚",
	"order_hotel_hoteldetail_tuigaixiangqing": "退改详情",
	"order_hotel_hoteldetail_ri": "日",
	"order_hotel_hoteldetail_yi": "一",
	"order_hotel_hoteldetail_er": "二",
	"order_hotel_hoteldetail_san": "三",
	"order_hotel_hoteldetail_si": "四",
	"order_hotel_hoteldetail_wu": "五",
	"order_hotel_hoteldetail_liu": "六",
	"order_hotel_hoteldetail_zhou": "周",
	"order_hotel_hoteldetail_wuzao": "无早",
	"order_hotel_hotelorderinfo_yueri": "MM月DD日",
	"order_hotel_hotelorderinfo_jian": "间",
	"order_hotel_hotelorderinfo_wan": "晚",
	"order_hotel_hotelorderinfo_weibeizhengce": "违背政策",
	"order_hotel_hotelorderinfo_jiudianxiangqing": "酒店详情",
	"order_hotel_hotelorderinfo_tuigaiguize": "退改规则",
	"order_hotel_hotelorderinfo_yiquxiao": "已取消",
	"order_hotel_hotelorderinfo_wozhidaoliao": "我知道了",
	"order_hotel_hotelorderinfo_weibeizhengceyuanyin": "违背政策原因：{0}",
	"order_hotel_hotelorderinfo_quchuli": "去处理",
	"order_hotel_hotelorderinfo_fuhezhengcedingdanshenpi": "符合政策订单审批",
	"order_hotel_hotelorderinfo_mingxi": "明细",
	"order_hotel_hotelorderinfo_shenqingtuifang": "申请退房",
	"order_hotel_hotelorderinfo_quxiaotuifang": "取消退房",
	"order_hotel_hotelorderinfo_quxiaodingdan": "取消订单",
	"order_hotel_hotelorderinfo_shenpi": "审批",
	"order_hotel_hotelorderinfo_shenqingren": "申请人：{0}",
	"order_hotel_hotelorderinfo_gaiqianren": "改签人：{0}",
	"order_hotel_hotelorderinfo_gaiqianyuanyin": "改签原因：{0}",
	"order_hotel_hotelorderinfo_wuzao": "无早",
	"order_orderInfo_yunxutuipiao": "允许退票",
	"order_orderInfo_jujuetuipiao": "拒绝退票",
	"order_orderInfo_yunxugaiqian": "允许改签",
	"order_orderInfo_jujuegaiqian": "拒绝改签",
	"order_orderInfo_shenpitongguo": "审批通过",
	"order_orderInfo_shenpijujue": "审批拒绝",
	"order_orderInfo_tuipiaoren": "退票人",
	"order_orderInfo_tuipiaoyuanyin": "退票原因",
	"order_orderInfo_gaiqianren": "改签人",
	"order_orderInfo_gaiqianyuanyin": "改签原因",
	"order_orderInfo_chuxingren": "出行人",
	"order_orderInfo_chuxingmudi": "出行目的",
	"order_orderdetails_dingdanxiangqing": "订单详情",
	"order_orderdetails_dingdanhao": "订单号:{0}",
	"order_orderdetails_ruzhurenxinxi": "入住人信息",
	"order_orderdetails_chuhangrenxinxi": "出行人信息",
	"order_orderdetails_shouji": "手机",
	"order_orderdetails_shenfenzheng": "身份证",
	"order_orderdetails_shanglvxinxi": "商旅信息",
	"order_orderdetails_chengbenzhongxin": "成本中心",
	"order_orderdetails_chalvmudi": "差旅目地",
	"order_orderdetails_xiangmudaima": "项目代码",
	"order_orderdetails_lianxiren": "联系人",
	"order_orderdetails_xingming": "姓名",
	"order_orderdetails_youxiang": "邮箱",
	"order_orderdetails_xuqiubeizhu": "需求备注",
	"order_orderdetails_fujianxinxi": "附件信息",
	"order_orderdetails_fujianmingcheng": "附件名称",
	"order_orderdetails_caozuo":"操作",
	"order_orderdetails_w": "无",
	"order_orderdetails_koukuanshuoming": "扣款说明:",
	"order_orderdetails_hgjndfkfsjhysqhkcffr": "会根据您的付款方式进行预授权或扣除房费，如订单不确认 将解除预授权或全额退款至您的付款账户。该订单确认后不 可被取消修改，若未入住将收取您首日房费，如提前离店将 扣除提前离店当天的费用。",
	"order_orderdetails_tebietishi": "特别提示:",
	"order_orderdetails_gjddrzsjwtfbzjssjwrt": "该酒店的入住时间为14:00，退房标准结算时间为12:00。如 提前入住或推迟离店，均须酌情加收一定的费用。",
	"order_orderdetails_zongji": "总计:",
	"order_orderdetails_mingxi": "明细",
	"order_orderdetails_feiyongmingxi": "费用明细",
	"order_orderdetails_baoxianfei": "保险费",
	"order_orderdetails_fuwufei": "服务费",
	"order_orderdetails_zonge": "总额",
	"order_orderdetails_tuigaiguize": "退改规则",
	"order_orderdetails_ri": "日",
	"order_orderdetails_yi": "一",
	"order_orderdetails_er": "二",
	"order_orderdetails_san": "三",
	"order_orderdetails_si": "四",
	"order_orderdetails_wu": "五",
	"order_orderdetails_liu": "六",
	"order_orderdetails_zhou": ")} (周${week})",
	'order_orderdetails_yiwancheng':"已完成",
	'order_orderdetails_yiquxiao':"已取消",
	'order_orderdetails_yituihui':"已退回",
	'order_orderdetails_daishenpi':"待审批",
	'order_orderdetails_daichuli':"待处理",
	'order_orderdetails_daiqueren':"待确认",
	"order_orderdetails_tuifangchulizhong":"退房处理中",
	"order_orderdetails_tuituanchulizhong":"退团处理中",
	"order_orderdetails_tuipiaochulizhong":"退票处理中",
	"order_orderdetails_youtuifang":"有退房",
	"order_orderdetails_youtuituan":"有退团",
	"order_orderdetails_youtuipiao":"有退票",
	"order_orderdetails_gaiqianchulizhong":"改签处理中",
	"order_orderdetails_yougaiqian":"有改签",
	"order_orderdetails_quanbugaiqian":"全部改签",
	"order_orderdetails_quanbutuifang":"全部退房",
	"order_orderdetails_quanbutuipiao":"全部退票",
	"order_orderdetails_quanbugaiqianzhong":"全部改签中",
	"order_orderdetails_quanbutuifangzhong":"全部退房中",
	"order_orderdetails_quanbutuipiaozhong":"全部退票中",
	"order_orderlist_wodedingdan": "我的订单",
	"order_orderlist_meiyougengduoliao": "没有更多了",
	"order_orderlist_yudingshijian": "预定时间：",
	"order_orderlist_weibeizhengce": "违背政策",
	"order_orderlist_fuhezhengce": "符合政策",
	"order_orderlist_chufa": "出发",
	"order_orderlist_zhi": "至",
	"order_orderlist_wei": "为",
	"order_orderlist_yuding": "预定",
	"order_orderlist_yueri": "MM DD ",
	"order_orderlist_jipiao": "机票",
	"order_orderlist_jiudian": "酒店",
	"order_orderlist_huoche": "火车",
	"order_orderlist_zuche": "租车",
	"order_train_traindetail_di": "第{0}",
	"order_train_traindetail_cheng": "程",
	"order_train_traindetail_yueri": "MM月DD日",
	"order_train_traindetail_tuigaiguize": "退改规则",
	"order_train_trainorderinfo_dancheng": "(单程)",
	"order_train_trainorderinfo_weibeizhengce": "违背政策",
	"order_train_trainorderinfo_gongxiang": "共享",
	"order_train_trainorderinfo_jianpiaokou": "检票口",
	"order_train_trainorderinfo_zhida": "直达",
	"order_train_trainorderinfo_zongyongshi": "总用时：{0}",
	"order_train_trainorderinfo_nianyueri": "YYYY年M月DD日 ddd",
	"order_train_trainorderinfo_tuigaiguize": "退改规则",
	"order_train_trainorderinfo_yiquxiao": "已取消",
	"order_train_trainorderinfo_tuipiaoshuoming": "退票说明",
	"order_train_trainorderinfo_dgcgwqpqfcqsjdyfzkjr": "1、代购成功，未取票且发车前时间大于35分钟，可进入“我的订单”，点击火车订单根据提示申请退票；发车前8天以内的退票，铁路局将对每张车票按梯次收取退票手续费。",
	"order_train_trainorderinfo_dgcgyqphfcqsjxyfzxnz": "2、代购成功，已取票或发车前时间小于35分钟，需您自行携带购票时所使用的乘车人有效证件原件和火车票在发车前去火车站退票窗口办理退票。",
	"order_train_trainorderinfo_gaiqianshuoming": "改签说明",
	"order_train_trainorderinfo_wqzzpqlfcsjdyfzkgqdy": "1、未取纸质票，且离发车时间大于35分钟，可改签等于或低于原车票票价的车次。其他不能在线改签的情况需在发车前至火车站窗口办理。",
	"order_train_trainorderinfo_kcqxsyskgqysqndcckcq": "2、开车前48小时以上，可改签预售期内的车次。开车前48小时以内，可改签至票面当天24：00之前任意车次，不办理票面日期次日及以后的改签",
	"order_train_trainorderinfo_xcppjdyycpdthcédcébf": "3、新车票票价低于原车票的，退还差额，对差额部分核收退票费并执行现行退票费标准。",
	"order_train_trainorderinfo_wozhidaoliao": "我知道了",
	"order_train_trainorderinfo_mingxi": "明细",
	"order_train_trainorderinfo_weibeizhengceyuanyin": "违背政策原因：{0}",
	"order_train_trainorderinfo_quchuli": "去处理",
	"order_train_trainorderinfo_fuhezhengcedingdanshenpi": "符合政策订单审批",
	"order_train_trainorderinfo_gaiqian": "改签",
	"order_train_trainorderinfo_tuipiao": "退票",
	"order_train_trainorderinfo_quxiaotuipiao": "取消退票",
	"order_train_trainorderinfo_quxiaogaiqian": "取消改签",
	"order_train_trainorderinfo_quxiaodingdan": "取消订单",
	"order_train_trainorderinfo_shenpi": "审批",
	"order_train_trainorderinfo_shenqingren": "申请人：{0}",
	"order_train_trainorderinfo_gaiqianren": "改签人：{0}",
	"order_train_trainorderinfo_gaiqianyuanyin": "改签原因：{0}",
	"order_train_trainorderinfo_xiangqingyuanyin": "详情原因：{0}",
	"system_newaddress_shezhimorendizhi": "设置默认地址",
	"system_newaddress_shanchu": "删除",
	"system_about_about_lichengshanglv": "力程商旅",
	"system_approvalset_provisionalauthorization_linshishenpishouquan": "临时审批授权",
	"system_approvalset_provisionalauthorization_qingxuanze": "请选择",
	"system_approvalset_provisionalauthorization_shouquanyuangong": "授权员工",
	"system_approvalset_provisionalauthorization_kaishiriqi": "开始日期",
	"system_approvalset_provisionalauthorization_xuanzeshijian": "选择时间",
	"system_approvalset_provisionalauthorization_jiezhishijian": "截止时间：",
	"system_approvalset_provisionalauthorization_shouquanshichang": "授权时长",
	"system_approvalset_provisionalauthorization_xiaoshi": "小时",
	"system_approvalset_provisionalauthorization_tian": "天",
	"system_approvalset_provisionalauthorization_shi": "时",
	"system_approvalset_list_baocun": "保存",
	"system_approvalset_list_shouquanliebiao": "授权列表",
	"system_approvalset_list_yijianqingchu": "一键清除",
	"system_approvalset_list_yiguoqi": "已过期",
	"system_approvalset_list_shouquanzhong": "授权中",
	"system_approvalset_list_quxiaoxiugai": "取消修改",
	"system_approvalset_list_qingxuanzeshouquanyuangong": "请选择授权员工",
	"system_autoupdate_autoupdate_faxianxinbanben": "发现新版本",
	"system_autoupdate_autoupdate_xinzeng": "{0}.新增{1}",
	"system_autoupdate_autoupdate_lijigengxin": "立即更新",
	"system_configinfo_configinfo_baocun": "保存",
	"system_configinfo_configinfo_peizhiguanli": "配置管理",
	"system_configinfo_configinfo_youxiang": "邮箱",
	"system_configinfo_configinfo_weixin": "微信",
	"system_configinfo_configinfo_daishenpi": "待审批",
	"system_configinfo_configinfo_daiqueren": "待确认",
	"system_configinfo_configinfo_daizhifu": "待支付",
	"system_configinfo_configinfo_daichuli": "待处理",
	"system_configinfo_configinfo_yiwancheng": "已完成",
	"system_configinfo_configinfo_baocunchenggong": "保存成功",
	"system_download_download_banbenhao": "版本号：V1.16",
	"system_download_download_daxiao": "大小：8.75MB",
	"system_download_download_jieshao": "介绍",
	"system_download_download_yingyongjieshao": "应用介绍",
	"system_download_download_slcglqxdqyslglxtykqd": "APP是力程国旅旗下的企业商旅管理系统，依靠强大的资源，先进的技术，优质的服务和专业的管理，帮助众多企业优化商务出差，预订及授权审批流程。",
	"system_download_download_yonghukeyitongguo": "用户可以通过",
	"system_download_download_xtksdjhjpjdhcpdcxyds": "APP系统快速的进行机票、酒店、火车票的查询、预订、审批等服务，能让差旅管理智能化，做到用户出差不借款，不垫资，不报账，提高用户差旅满意度。真正做到帮助企业降低消费成本，简化财务报销流程，提升运营效率。",
	"system_download_download_zhuyaogongneng": "主要功能",
	"system_download_download_àcsrqqfsjdxxcxbydjpj": "1、按城市、日期、起飞时间等信息查询并预订机票、酒店、火车票；",
	"system_download_download_qyyjdpwxygdkjkdphsxy": "2、企业月结订票（无需员工垫款即可订票）和授信员工管理；",
	"system_download_download_qingsongchakanguanlidingdanyijiantuipiaogaiqian": "3、轻松查看管理订单，一键退票改签；",
	"system_download_download_zcqydcbgkszydgczlhgk": "4、支持企业的差标管控设置，预订过程中灵活管控。帮助企业更好地执行差旅政策，节约成本。",
	"system_feedback_feedback_fankuileixing": "反馈类型",
	"system_feedback_feedback_fankuineirong": "反馈内容",
	"system_feedback_feedback_wltgwmdfwhzlwmwntgfw": "为了提高我们的服务和质量,我们为您提供服务投诉和建议的专用通道,将第一时间反馈到大BOSS手中！",
	"system_feedback_feedback_shangchuanzhaopian": "上传照片",
	"system_feedback_feedback_shangchuantupianshuomingkeyigengfangbianwomenlijienindexuqiuo": "上传图片说明可以更方便我们理解您的需求哦",
	"system_feedback_feedback_yibianwomengeininhuifu": "以便我们给您回复",
	"system_feedback_feedback_shoujihao": "手机号:",
	"system_feedback_feedback_qitalianxifangshiyouxiang": "其他联系方式(邮箱/QQ...)",
	"system_feedback_feedback_qita": "其他",
	"system_feedback_feedback_tijiao": "提交",
	"system_feedback_feedback_yijianfankui": "意见反馈",
	"system_feedback_feedback_shijuetiyan": "视觉体验",
	"system_feedback_feedback_caozuotiyan": "操作体验",
	"system_feedback_feedback_zhengzaishangchuan": "正在上传",
	"system_feedback_feedback_shangchuanchenggong": "上传成功",
	"system_feedback_feedback_shangchuanshibai": "上传失败",
	"system_feedback_feedback_qingtianxienindebaoguiyijianhuoshangchuanzhaopian": "请填写您的宝贵意见或上传照片",
	"system_feedback_feedback_tijiaochenggongganxienindefankui": "提交成功,感谢您的反馈",
	"system_mall_addinvoice_shanchu": "删除",
	"system_mall_addtraveller_shanchu": "删除",
	"system_mall_modules_travelername_xingmingxuyuxiedaichuhangdezhengjianyizhifouzehuiyingxianghangcheng": "姓名需与携带出行的证件一致，否则会影响行程",
	"system_mall_modules_travelername_tianxiexuzhi": "填写须知",
	"system_mall_modules_travelername_yitianxieshuoming": "一.填写说明",
	"system_mall_modules_travelername_chengkexingmingxuyudengjisuochizhengjianshangdemingziyizhi": "1.乘客姓名需与登机所持证件上的名字一致。",
	"system_mall_modules_travelername_wqbslchqqblhjsrqzsbz": "2.为确保顺利出行，请确保旅行结束日期至少比证件有效期早6个月，并确认填写真实、有效的证件号码，订单提交后将无法修改。",
	"system_mall_modules_travelername_erxinbanhuzhao": "二.新版护照",
	"system_mall_modules_travelername_sanjiubanhuzhao": "三.旧版护照",
	"system_mall_modules_travelername_sigangaotonghangzheng": "四.港澳通行证",
	"system_mall_modules_travelername_wutaiwantonghangzheng": "五.台湾通行证",
	"system_mall_modules_travelername_liutaibaozheng": "六.台胞证",
	"system_mall_oftenpassenger_gongsichangke": "公司常客",
	"system_mall_oftenpassenger_gerenchangke": "个人常客",
	"system_messagenotify_messagenotify_gong": "共",
	"system_messagenotify_messagenotify_tiaoxiaoxi": "条消息",
	"system_messagenotify_messagenotify_weiduxiaoxi": "未读消息",
	"system_messagenotify_messagenotify_yiduxiaoxi": "已读消息",
	"system_messagenotify_messagenotify_zanwuxiaoxi": "暂无消息",
	"system_messagenotify_messagenotify_xiaoxitongzhi": "消息通知",
	"system_messagenotify_messagenotify_quanbuxiaoxi": "全部消息",
	"system_messagenotify_messagenotify_xitongtongzhi": "系统通知",
	"system_messagenotify_messagenotify_xiaoxitixing": "消息提醒",
	"system_messagenotify_notifyitem_xitongtongzhi": "系统通知",
	"system_messagenotify_notifyitem_xiaoxitixing": "消息提醒",
	"system_messagenotify_notifyitem_ganggang": "刚刚",
	"system_messagenotify_notifyitem_shanchu": "删除",
	"system_modules_calendar_zhongzhi": "重置",
	"system_modules_calendar_ri": "日",
	"system_modules_calendar_yi": "一",
	"system_modules_calendar_er": "二",
	"system_modules_calendar_san": "三",
	"system_modules_calendar_si": "四",
	"system_modules_calendar_wu": "五",
	"system_modules_calendar_liu": "六",
	"system_modules_calendar_yuandan": "元旦",
	"system_modules_calendar_qingmingjie": "清明节",
	"system_modules_calendar_laodongjie": "劳动节",
	"system_modules_calendar_guoqingjie": "国庆节",
	"system_modules_calendar_chuxi": "除夕",
	"system_modules_calendar_chunjie": "春节",
	"system_modules_calendar_duanwujie": "端午节",
	"system_modules_calendar_zhongqiujie": "中秋节",
	"system_user_account_account_jiebang": "解绑",
	"system_user_businessregister_qiyeyonghuzhuce": "企业用户注册",
	"system_user_businessregister_ruguigongsiyishilichengshanglvqianyueqiye": "如贵公司已是力程商旅签约企业，",
	"system_user_businessregister_qinglianxinindechalvfuzerenhuoquzhanghaowuzhongfuzhuce": "请联系您的差旅负责人获取账号，勿重复注册",
	"system_user_businessregister_qingshuruninqiyemingcheng": "请输入您企业名称",
	"system_user_businessregister_qiyemingcheng": "企业名称",
	"system_user_businessregister_shoujihaohuoyouxiangzhuce": "手机号或邮箱注册",
	"system_user_businessregister_shoujihao": "手机号",
	"system_user_businessregister_qingshuruyanzhengma": "请输入验证码",
	"system_user_businessregister_yanzhengma": "验 证 码",
	"system_user_businessregister_qingshuruguiqiyesuoshuhangye": "请输入贵企业所属行业",
	"system_user_businessregister_qiyehangye": "企业行业",
	"system_user_businessregister_qingshuruguiqiyediqu": "请输入贵企业地区",
	"system_user_businessregister_qiyediqu": "企业地区",
	"system_user_businessregister_qingtianxielianxirenxingming": "请填写联系人姓名",
	"system_user_businessregister_lianxiren": "联 系 人",
	"system_user_businessregister_zhucezhanghao": "注册账号",
	"system_user_businessregister_qingshezhidenglumima": "请设置登录密码",
	"system_user_businessregister_denglumima": "登录密码",
	"system_user_businessregister_zaicishurumima": "再次输入密码",
	"system_user_businessregister_querenmima": "确认密码",
	"system_user_businessregister_tongyi": "同意",
	"system_user_businessregister_fuwuxieyi": "服务协议",
	"system_user_businessregister_xiayibuyanzheng": "下一步，验证",
	"system_user_businessregister_wancheng": "完成",
	"system_user_businessregister_ruzhucechuxianwenti": "如注册出现问题",
	"system_user_businessregister_qingboda": "请拨打",
	"system_user_businessregister_lianxikefuweinijieda": "联系客服为你解答",
	"system_user_businessregister_zhuce": "注册",
	"system_user_businessregister_gongsimingchengbunengkong": "公司名称不能空",
	"system_user_businessregister_dangqianshoujihaoyibeizhuce": "当前手机号已被注册",
	"system_user_main_peizhiguanli": "配置管理",
	"system_user_modules_authorizat_qiyezhanghaoyouxiangshoujihao": "企业账号/邮箱/手机号",
	"system_user_modules_authorizat_qingshuruzhanghu": "请输入账户",
	"system_user_modules_authorizat_buqufendaxiaoxie": "不区分大小写",
	"system_user_modules_authorizat_qingshuruyanzhengma": "请输入验证码",
	"system_user_modules_authorizat_lijibangding": "立即绑定",
	"system_user_modules_authorizat_lijizhuce": "企业注册",
	"system_user_modules_authorizat_zhanghaobangding": "账号绑定",
	"system_user_modules_authorizat_shoujiyanzhengbangding": "手机验证绑定",
	"system_user_modules_ordinary_lijizhuce": "立即注册",
	"system_user_modules_ordinary_denglu": "登录",
	"system_user_modules_ordinary_xiugaichushimima": "修改初始密码",
	"system_user_modules_password_shezhimima": "设置密码",
	"system_user_modules_password_xiacidenglutixingwo": "下次登录提醒我",
	"user_resetpwd_mobilevalidate_yanzhengguize": "验证规则",
	"user_resetpwd_verifyidentity_zhaohuimima": "找回密码",
	"user_resetpwd_verifyidentity_dengluming": "登录名",
	"user_resetpwd_verifyidentity_zhucehuobangdingdeshoujihaohuoyouxiang": "注册或绑定的手机号或邮箱",
	"user_resetpwd_verifyidentity_haiwaishoujiqinganguojiadaimashoujihaomadegeshishururu": "海外手机请按“国家代码-手机号码的格式输入，如：79-66666666",
  "user_resetpwd_verifyidentity_xiayibu": "下一步",
  user:{
    companyName:'力程商旅'
  },
  router:{
    home:'首页',
    trip:'行程',
    my:'我的',
  },
  bill:{
    myOrder:'我的订单'
  },
  mall: {
    OnBusiness: "因公",
    OnPersonal: "因私",
    btriprule: '差旅规则',
    demandorder: '需求单',
    allprice: '全价',
    discount: '折',
    GivenName: '英文名',
    Surname: '英文姓',
    selectedseat: '已选座',
    noselectseat: '未选座',
    takeOff: '起飞',
    FillInfo: '填写须知',
    ExpiryDate: '有效期至',
    StartTime: '开始时间',
    EndTime: '结束时间',
    ToProcessDate: '去程日期',
    backTracking: '返程日期',
    sharing: '共享',
    AirplaneModelTxt: '机型',
    ticketfeeFloat: '此价格不含机建燃油税费',
    peopleTypeExplain: '儿童婴儿预订说明',
    bookingTicketExplain: '如需预订儿童/婴儿票，请联系本公司客服。',
    onlySeeDirect: '仅看直飞',
    hiddenSharedFlight: '隐藏共享航班',
    ActualCarrier: '实际承运',
    stayTxt: '停留',
    turnTxt: '转',
    priceRemarks: '以下费用均为“1成人或1儿童或1婴儿”的人均价',
    AgreementPrice: '商务推荐',
    tax: '税',
    trainHolderKeyWords: '国内火车票',
    bookingRemarks: '一次最多只能预订5位乘客',
    beginTxt: '始',
    passTxt: '过',
    endTxt: '终',
    StandingOrder: '站序',
    stationName: '站名',
    arrivalTimeTxt: '到时',
    departTimeTxt: '发时',
    departDate: '出发日期',
    arrivalDate: '到达日期',
    hotelHolderKeyWords: '请输入关键字/酒店名等',
    HotelRemarks: '订房间请不要超过5间，入住日期不要超过20晚。若需特殊预订请联系我司客服。',
    TrainRemarks: '提示：购票时间为早7:30—晚22:30。购票、改签和退票须不晚于开车前30分钟。当天内行程请在10分钟内支付，24小时以外行程请在25分钟内支付。',
    NoTrainSearch: '当前时段不提供车次查询服务',
    mapTxt: '地图/导航',
    detailsOrFacilities: '详情/设施',
    noSooner: '无早',
    breakfast: '早餐',
    breakfastTxt: '含早',
    noCancellation: '不可取消',
		timeToCancel: '限时取消',
		withWindow:"有窗",
    RoomsTxt: '房间数',
    hotelUnit: '晚',
    checkInTxt: '入住',
    checkOutTxt: '离店',
    checkInDate: '入住日期',
    checkOutDate: '离店日期',
    Frequenter: '常客',
    Temporary: '临客',
    TemporaryInformation: '临客信息',
    addFrequenter: '添加常客',
    addTemporary: '添加临客',
    TravelStandard: '差旅标准',
    hightToLow: '从高到低',
    lowToHight: '从低到高',
    morningToNight: '从早到晚',
    nightToMorning: '从晚到早',
    starLevelTxt: '星级',
    filtrateTxt: '筛选',
    timeTxt: '时间',
    fromTo: '起',
    portion: '份',
    contactNumber: '联系电话',
    conformToRules: '符合政策',
    breakToRules: '违背规则',
    unlimited: '不限',
    beforeDay: '前一天',
    afterDay: '后一天',
    adequateTxt: '充足',
    Remaining: '仅剩',
    taxesTxt: '税费',
    BackTorule: '退改规则',
    trainamendrule:'对开车前8天(不含)以上退票的，不收取退票费。票面乘车站开车前48小时以上的，退票时收取票价5%的退票费;开车前24小时以上、不足48小时的，退票时收取票价10%的退票费;开车前不足24小时的，退票时收取票价20%退票费。',
    booking: '订',
    onlinePay: '在线付',
    departTxt: '出发',
    arrivalTxt: '到达',
    sheet: '张',
    NoTicket: '无票',
    orderFilltitle: '订单填写',
    tripInfosTitle: '出行人信息',
    BookingInformation: '预订须知',
    tripInfosRemarks: '为了您顺利出行，请务必保证填写项与出游所持证件一致',
    addTraveller: '添加旅客',
    UserName: '姓名',
    contactInfosTitle: '联系人信息',
    RemarkInfosTitle: '备注信息',
    contacts: '联系人',
    Phone: '手机',
    Email: '电子邮件',
    InstructTitle: '扣款说明',
    InstructContent: '会根据您的付款方式进行预授权或扣除房费，如订单不确认将解除预授权或全额退款至您的付款账户。该订单确认后不可被取消修改，若未入住将收取您首日房费，如提前离店将扣除提前离店当天的费用。',
    SpecialTipsTitle: '特别提示',
    SpecialTipsContent: '该酒店的入住时间为14:00，退房标准结算时间为12:00。如 提前入住或推迟离店，均须酌情加收一定的费用。',
    travelInformationTitle: '差旅信息',
    CostCenter: '成本中心',
    TravelPurpose: '差旅目的',
    ProjectCode: '项目代码',
    contraryReason: '违背原因',
    ViolateTravelRules: '违背差旅规则',
    SpecialRequirement: '特殊需求',
    SpecialRequirementTips: '特殊需求备注',
    specialRequirementContent: '你的特殊要求，我们会尽量协调。如无法满足，我们不会 另行通知，请您见谅。',
    otherRequirement: '其他需求',
    consentAgreement: '点击提交表示已阅读并同意',
    importantTerms: '预订须知和重要条款',
    BookingHint: '为支持绿色环保,默认电子合同,若需要签订纸质合同请致电客服。',
    CostDetails: '费用明细',
    payTotalPrice: '应付总额',
    totalPrice: '总额',
    roomUnit: '房',
    nightUnit: '夜',
    peopleUnit: '人',
    details: '明细',
    CustomerService: '联系客服',
    SubmissionOrPayment: '提交/支付',
    frequentlnformationTitle: '旅客信息',
    TravellerTitle: '旅客姓名',
    EnglishName: '英文姓名',
    LastName: '英文姓',
    firstName: '英文名',
    NameOrIdCardTips: '为了确保顺利出行，请确保出行姓名与证件保持一致。',
    CertificateInformatTitle: '证件信息',
    ExpireDate: '证件有效期',
    otherInfosTitle: '其他信息',
    Sex: '性别',
    Birthday: '出生日期',
    Nationality: '国籍',
    optionalCard: '旅客卡（选填）',
    reminderInfos: '为了你能顺利出行，请确保旅行结束日期至少比证件有效期早6个月，并确认填写真实、有效的证件号码，订单提交后将无法修改',
    addOrEditTraveller: '添加编辑旅客',
    AllOrder: '全部',
    orderStatus: '订单状态',
    departTime: '出发时间',
    orderDetail: '订单详情',
    CancelOrder: '取消订单', 
    CancelRefund:'取消退票',
    CancelChange:'取消改签',
    ApprovalRefused: '审批拒绝',
    ApproveSucc: '审批通过',
    PayNow: '立即支付',
    Refund: '退票',
    RefundHotel:'退房',
    RefundGroup:'退团',
    Change: '改签',
    SubmitOrder: '提交订单',
    PriceDetail: '价格详情',
    CheckOrderProgress: '查看订单进度',
    flightInformation: '航班信息',
    orderNumber: '订单号',
    BookingTime: '预订时间',
    First: '第',
    Journey: '程',
    few: '间',
    Level: '级',
    BackToChangeTips: '最终金额以审核为准，如有疑问请拨打客服电话',
    pleaseChoose: '请选择',
    ThePassengers: '的旅客',
    Transfer: '经停',
    Flight: '航班',
    RefundRoomsDate: '退房入住时间',
    TheReason: '的原因',
    TheTrain: '的车次',
    hour: '小时',
    minute: '分钟',
    Gym: '健身房',
    district: '行政区',
    business: '商业区',
    ThePassengerInformation: '旅客信息',
    NewTrainInformation: '新车次信息',
    OriginalTrainInformation: '原车次信息',
    NewFlightInformation: '新航班信息',
    OriginalFlightInformation: '原航班信息',
    NextStep: '下一步',
    ChangeDate: '改签日期',
    SelectChangeFlight: '请选择改签的航班',
    SelectRefundFlight: '请选择退票的航班',
    SelectChangeTrain: '请选择改签的旅客',
    SelectRefundTrain: '请选择退票的旅客',
    SelectRefundHotel: '请选择退房的酒店',
    SelectChangeDate: '请选择改签日期',
    Department: '部门',
    ApprovalStatus: '审批状态',
    ConfidentialInformation: '凭证信息',
    TradeInformation: '交易信息',
    Insurance: '保险',
    Home: '首页',
    Stroke: '行程',
    Me: '我的',
    TravelApproval: '差旅审批',
    TravelRulesName: '差旅规则名称',
    MinimumPriceBase: '最低价格基准',
    RealFlightControl: '实时航班管控',
    AdvanceBookingTime: '提前预订时间',
    ClassLimit: '舱位级别限制',
    SeatClassLimit: '座位级别限制',
    AgreementAirlinePriority: '协议机票优先',
    AgreementHotelPriority: '协议酒店优先',
    MaximumAmountConsumption: '消费金额上限',
    ApprovalName: '审批名称',
    Other: '其他',
    FirstClassCity: '一级城市',
    SecondaryCity: '二级城市',
    ThreeLevelCity: '三级城市',
    SeatSelectionService: '选座服务',
    Bezel: '窗',
    Aisle: '过道',
    NewContacts: '新增联系人',
    AdditionalInvoiceInformation: '新增/编辑发票信息',
    InvoiceInformation: '发票信息',
    InvoiceTitle: '发票抬头',
    TariffItem: '税号',
    SetDefaultContacts: '设置默认联系人',
    ConsigneeAddress: '收件地址',
    NewCommonAddresses: '新增常用地址',
    default: '默',
    City: '城市',
    Address: '地址',
    Postcode: '邮编',
    AddCommonAddresses: '新增/编辑常用地址',
    DepartureTime: '起飞时间',
    Airport: '机场',
    ShippingSpace: '舱位',
    AirlineCompany: '航空公司',
    '150OrLess': '￥150以下',
    '150And300': '￥150-300',
    '300And450': '￥300-450',
    '450And600': '￥450-600',
    '600OrMore': '￥600以上',
    TwoStarsOrLess: '二星及以下',
    ThreeStar: '三星级/舒适',
    FourStar: '四星级/高档',
    FivesStar: '五星级/豪华',
    Apartment: '公寓',
    Inn: '客栈',
    FamilyInn: '家庭旅馆',
    YouthHostel: '青年旅舍',
    CoupleHotel: '情侣酒店',
    GardenCourtyard: '园林庭院',
    SeaView: '海景',
    Farmhouse: '农家乐',
    HotSpringHotel: '温泉酒店',
    GolfHotel: '高尔夫酒店',
    Siheyuan: '四合院',
    Villa: '别墅',
    PartyCooking: '聚会做饭',
    BusinessTtravelHome: '商旅之家',
    LeisureMood: '休闲情调',
    SeeDoctor: "看病就医",
    VacationLeisure: "度假休闲",
    TrainAndLearn: "培训学习",
    GetTogether: "聚会",
    HoneymoonTrip: "蜜月出行",
    boutiqueHotel: "精品酒店(设计师酒店)",
    FreeWifi: "免费wifi",
    FreeParking: "免费停车场",
    IndoorPool: "室内游泳池",
    OutdoorPool: "室外游泳池",
    service: "健身房",
    BusinessCenter: "商务中心",
    MeetingRoom: "会议室",
    HotelRestaurant: "酒店餐厅",
    MorningCall: "叫醒服务",
    LuggageStorage: "行李寄存",
    TwinBed: "双床",
    BigBed: "大床",
    FreePickUpService: "免费接机服务",
    Price: '价格',
    StarLevel: '星级',
    Specialtie: '特色',
    Service: '设施服务',
    DetailsOrFacilities: '详情/设施',
    HotelDetail: '酒店详情',
    ModelSelection: '机型选择',
    HighSpeedRail: '高铁(G/C)',
    MotorCar: '动车(D)',
    Ordinary: '普通(Z/T/K)',
    DepartureOrArrival: '出发/到达车站',
    Date: '日期',
    Status: '状态',
    OldSystem: '请使用PC版查看',
    Welcome: '欢迎您',
    PleaseLogIn: '请登录',
    FlightTips: '低价机票，舒适出行',
    HotelTips: '尊享入住，商旅独享',
    TrainTips: '一键闪电出票',
    TourTips: '精选特价旅游',
    Invoice: '发票抬头',
    InvoiceType: '发票类型',
    Identifier: '识别号',
    TicketInquiry: '机票查询',
    TrainInquiry: '火车查询',
    HotelInquiry: '酒店查询',
    ConsumerHotline: "客服电话",
    WeChatService: "微信客服",
    TravelPolicy: '差旅政策',
    EditData: '编辑资料',
    RecommendFlight: '推荐航班',
	voyageinfos: "航程信息",
	passinfos: "乘客信息",
    passnum: "乘客人数",
	cabinlevel: "舱位等级",
	consumertype: "乘客类型",
	sui: "岁",
    twosui: "两岁以下",
    firstairway: "首选航空公司",
	demandprobtip: "如提交出现问题请咨询：",
	submit: "提交",
	remark: "备注",
	email: "邮箱",
	contact: "联系人",
    phoneno: "手机号码",
	contactinfo: "联系人信息",
	normal: "普通",
    student: "学生",
    newimmigrant: "新移民",
    worker: "劳务",
	adult: "成人",
    child: "儿童",
    infant: "婴儿",
	departcity: "出发城市",
    arrivecity: "到达城市",
    departdate: "出发时间",
    arrivedate: "到达时间",
	selectdate: "请选择日期",
	delete: "删除",
	addvoyage: "添加航程",
    notificationMessageFlight: "通知：若有需要，可点此进入国际需求单，更多更低价国际机票。满足您的任何差旅需求也可致电：",
	noVoyage:'无满足航程？',
	foundRequirement:'创建需求单',
	Hotline: "热线咨询。",
    OriginalFlight: '原航班',
    More: '更多',
    MoreInfo: '更多信息',
    Hidden: '隐藏',
    JetFuel: '含机建燃油',
    Booking: '预订',
    CurrentPosition: '当前位置',
    Room: '房间',
    SquareMeters: '平米',
    CanLive: '可住',
    Floor: '楼层',
    Layer: '层',
    ServiceFee: '服务费',
    InsurancePremium: '保险费',
    Yuan: '元',
    ContactHotel: '联系酒店',
    After: '后',
    Before: '前',
    For: '为',
    DueTo: '预订于',
    ViolationPolicy: '违背政策',
    CompliancePolicy: '符合政策',
    BusinessInformation: '商旅信息',
    Within: '以内',
    RefuseReason: '审批备注',
    Against: '违背了',
    Policy: '的政策',
    DetailedReason: '详情原因',
    Wait: '等待',
    Approval: '审批',
    Breach: '违背',
    AirlineAuditStandards: '以航空公司最新规定为准，可咨询客服电话',
    ConfirmOrder: '确认订单',
    FlightInformation: '航程信息',
    Voyage: '航程',
    DeparturePlace: '出发地点',
    ArrivePlace: '到达到点',
    AddVoyage: '添加航程',
    PassengersNumbers: '乘客人数',
    ShipType: '舱位类型',
    PassengersType: '乘客类型',
    ShipCompany: '首选航司',
    Remarks: '备注',
    PackUp: '收起',
    Show: '展开',
    DocumentType: '证件类型',
    CardNo: '证件号码',
    InvoiceRole: '发票角色',
    BankName: '银行名称',
    BankAccount: '银行账号',
    RegisteredAddress: '注册地址',
    RegisteredPhone: '注册电话',
    ChangeReason: '改签原因',
    VoucherNumber: '凭证号',
    CancelReason: '取消原因',
    ChildInfantBooking: '儿童婴儿预订说明',
    boyin: '波音',
    kongke: '空客',
    AppropriationBudget: '经费预算',
    Attendance: '参会人数',
    HostPlace: '举办地点',
    Destination: '目的地',
    ParticipantsNumber: '参加人数',
    ActivityBudget: '活动预算',
    AmountPaid: '需要支付金额',
    ConfirmPayment: '确认支付',
    Pay: '付',
    PriceTxt: '价',
	ReserveHint:'当前为非联程航班，如遇其中一程航班变动，另一程若需办理退改乘客需自行承担相应退改费用。'
  },
  placeholders: {
    UserID: "请输入用户名",
    Password: "请输入密码",
    UserPhone: "请输入手机号",
    contacts: '请填写联系人姓名',
    Email: '用于接收确认单',
    CostCenter: '请选择成本中心',
    TravelPurpose: '请选择差旅目的',
    ProjectCode: '请填写项目代码',
    CauseName: '请选择违背原因',
    CauseDetails: '请填写详细违背原因',
    searchTraveller: '请输入姓名',
    SearchZones: '城市、车站的中文或拼音',
    UserName: '与证件姓名一致',
    LastName: '如：张飞，填：ZHANG',
    firstName: '如：张飞，填：FEI',
    CardNo: '所持证件号码',
    Phone: '请输入手机号码',
    RecipientAddress: '请输入收件人地址',
    RecipientPostcode: '请输入收件人邮编',
    OriginalPassword: '请输入原密码',
    NewPassword: '请输入新密码',
    AffirmNewPassword: '请确认密码',
    CompanyName: '请输入企业名称',
    SelectCity: '请选择城市',
    Industry: '请输入行业',
    Account: '请输入手机号或邮箱',
    VerificationCode: '请输入验证码',
    DynamicCode: '请输入动态码',
    RegisterPhone: '请注册或绑定手机号！',
    Invoice: '发票抬头',
    InvoiceType: '发票类型',
    Identifier: '必填，纳税人识别号',
    RefusalCause: '请输入拒绝原因',
    CaseInsensitive: '不区分大小写',
    MessageAuthenticationCode: '短信验证码',
    DeparturePlace: '出发地点',
    ArrivePlace: '到达到点',
    ContactEmail: '请输入邮箱',
    Remarks: '请输入备注',
    ShipCompany: '首选航司',
    BankName: '银行名称',
    BankAccount: '银行账号',
    RegisteredAddress: '注册地址',
    RegisteredPhone: '注册电话',
    TrainDetailReason: '火车详情原因',
    PeopleNumber: '请输入人数',
    AppropriationBudget: '请输入预算经费',
    ContactNumber: '请输入联系电话',
    ContactRemarks: '告诉我们您最方便的联系时间及方式，让我们在最恰当的时间回复您。'
  },
  system: {
    Customer: "在线客服",
    EmailNotification:'邮件通知',
    servicePhone: '400-088-8020',
    Company: '力程商旅',
    Name: '力程商旅',
    contacts: '联系信息',
    HowToCall: '大家该怎么称呼您',
    PerfectInformation: '请完善手机号码',
    BindingPhone: '绑定手机',
    BindingEmail: '绑定邮箱',
    AccountAssociated: '账号关联',
    UpdatePassword: '修改登录密码',
    Language: '语言',
    Chinese: '中',
		English: '英',
		Japanese:'日',
    ExitLogin: '退出登录',
    WeChat: '微信',
    ImmediatelyBinding: '立即绑定',
    Password: '密码',
    OriginalPassword: '原密码',
    NewPassword: '新密码',
    AffirmNewPassword: '确认密码',
    ChangePassword: '修改密码',
    EditPersonalInformation: '编辑个人资料',
    CompanyName: '企业名称',
    Industry: '行业',
    Account: '我的账户',
    VerificationCode: '验证码',
    DynamicCode: '动态码',
    RegisterNow: '立即注册',
    Register: '注册',
    UserRegister: '个人注册',
    CompanyRegister: '企业注册',
    ServiceAgreement: '同意《力程旅行网服务协议》',
    SendDynamicCode: '发送动态码',
    Sent: '已发送',
    LoginTxt: '登录',
    DynamicPasswordLogin: '动态密码登录',
    ForgetPassword: '忘记密码',
    Integral: '积分',
    AllOrders: '全部订单',
    Obligation: '待付款',
    NotToTravel: '未出行',
    ToApproval: '待审批',
    TicketInformation: '票证信息',
    OrderInformation: '订单信息',
    OrderID: '订单编号',
    TradeID: '交易编号',
    TradeAmount: '订单总金额',
    CollectingCompany: '收款公司',
    PaymentWays: '支付方式',
    Payment: '支付',
    ThePassengerInformation: '旅客信息',
    PassWordLogin: '密码登录',
    CodeLogin: '验证码登录',
    Notice: '通知',
    RecentOrders: '近期行程',
    Reserved: '待订妥',
    CustomerService: '客服',
    Sell: '销售',
    ContactUs: '联系我们',
    Call: '呼叫',
    ServiceDept: '客服部',
    MyOrder: '我的订单',
    ApprovalDispose: '审批处理',
    RetrievePwd: '便于登录或找回密码',
    ElectronicBills: '便于接收电子账单',
    ApprovalAccredit: '审批授权',
    AboutUs: '关于我们',
    TestGetCode: '获取验证码',
    PhoneHint: '您可以通过绑定的手机重置密码。',
    EmailHint: '您可以通过绑定的邮箱重置密码。',
    LoginPassword: '登录密码',
    ResetPassword: '重置密码',
    EnterAccount: '输入账号',
    PhoneVerification: '手机验证',
    EmailVerification: '邮箱验证',
    SetBinding: '设置绑定',
    Input: '输入',
    Effective: '有效的',
    Verify: '验证',
    NextStep: '下一步',
    RemarkString: '退改签时限',
    RefundFee: '退票费',
    Cabinfee: '同舱改期费',
    ReimburseInfo: '报销信息',
    BaggageAllowance: '行李额',
    BackChangeRemark: '以上成人退改签规则及费用标准，仅供参考，实际需以航司为准.',
    PartRoute: '部分航线',
    PartHotel: '部分酒店',
    IsSaveCustomers: '是否保存常客',
    EmployeeRights: '员工权限',
    DateGranted: '授予日期',
    ExpiryDate: '过期日期',
    AddApproval: '添加/修改审批',
    AddApprovals: '添加审批',
    DownloadInstall: '下载安装',
    TopRightCorner: '请点击右上角',
    BrowserOpen: '选择"浏览器中打开"',
    CannotDownloaded: '微信/QQ内无法下载应用',
    CompanyProfile: '公司概况',
    CompanyProfileContent: '上海力程官网(www.lichengtrip.net)隶属于上海力程票务有限公司，公司总部设在中国上海，总部办公地点位于上海市长宁区新东纺国际商务中心，紧临静安寺曹家渡等商务中心地段，内设呼叫中心、总经办、财务部、票务结算部、国际部、国内同行部、客户服务部、培训部、商务部、运营中心等相应部门。是上海销售范围较广、服务规模较大、综合实力较强的大型民航服务企业。',
    FutureProspects: '未来前景',
    FutureProspectsContent: '在互联网技术迅猛发展的21世纪，上海力程联合科研单位研发的商旅分销系统，用具有独立知识产权的先进技术，以方便快捷的流线型工程服务于天下民众生活的方方面面，让每一个生活在网络社会的普通百姓，都有机会成为网络经济大潮的弄潮儿。使他们在分分秒秒的网络生活体验中，感受到中华民族优秀传统文化和现代民主生活方式的完美融合，感受到实实在在的人文关爱和物质生活的不断丰富与提升，为推动网络社会健康、和谐、稳定发展，奉献出力程人的全部热情和智慧!2016年是力程迎来更高发展的时刻，以创新和进取为动力，进一步加快发展速度，提升发展品质，以国际、国内机票销售为主体、度假预订并举，实施全面发展战略，着力推进信息化、构建信息平台。',
    ManagementTeam: '紧密精进的管理团队',
    ManagementTeamContent: '上海力程的管理团队在资源合作、管理技能、业务经验上的完美组合，以及团队间紧密贴切的合作保证了公司迅速稳健的发展。我们的高层管理团队集合了国际IT业、旅游业及金融业多年业务运作与管理的经验；中层管理团队汇集了中国IT业、航空代理业及旅游业的，保证了服务规模化和资源规模化的管理方针。',
    TechnicalService: '技术领先与服务',
    TechnicalServiceContent: '力程一直将技术创新视为企业的活力源泉，在提升研发能力方面不遗余力。力程建立了一整套现代化服务系统，以创新和进取为动力，进一步加快发展速度，提升发展品质，以国际、国内机票销售为主体、酒店预订、度假预订并举，实施全面发展战略，着力推进信息化、构建信息平台。',
    AboutUsContent: '电话：400-088-8020',
  },
  share: {
    hot: '热门',
    calendarDataTitle: '选择日期',
    calendarDataExplain: '查询日期为出发日期',
    cancelTxt: "取消",
    confirmTxt: "确定",
    pullUpLoadMoreTxt: '加载更多',
    pullUpLoadNoMoreTxt: '没有更多',
    RefreshTheSuccess: '刷新成功',
    Save: '保存',
    Add: '添加',
    QueryBtn: '查询',
    SubmitBtn: '提交',
    AmendBtn: '修改',
    FinishBtn: '完成',
    fail: {
      CancelOrder:'请选择取消订单',
      RefundOrder:'请选择取消退票订单',   
      selectTraveller: '请选择旅客！',
      minPrice: '您选择不是推荐航班或舱位，确定要继续预订？',
      CostCenter: '请输入成本中心！',
      TravelPurpose: '请输入差旅目的！',
      EnglishName: '该乘客没有英文名称！',
      RefundJourney: '请选择您需要退票的行程！',
      RefundReason: '请选择您需要退票的原因！',
      RefundTraveller: '请选择您需要退票的旅客！',
      ChangeJourney: '请选择您需要改签的行程！',
      ChangeTraveller: '请选择您需要改签的旅客！',
      ChooseAnotherFlight: '请选择其他航司的航班！',
      TheCorrectName: '请输入正确的姓和名！',
      UsreNameRepetition: '乘客名不能重复！',
      RegisterPhone: '请注册或绑定手机号！',
      VerificationCode: '请输入验证码',
      DynamicCode: '请输入动态码',
      PassengerSurname: '请输入旅客姓',
      PassengerName: '请输入旅客名',
      RefusalCause: '请填写拒绝原因！',
      PhoneBinding: '绑定的手机号不能空',
      EmailBinding: '绑定的邮箱不能空',
      Phone: '请输入正确的手机号',
      Email: '请输入正确的邮箱',
      VerificationTime: '每隔60s才能获取一次验证码',
      Account: '请输入账号',
      AccountEmpty: '账号不能为空',
      PasswordEmpty: '密码不能为空',
      PassengersNumbers: '旅客数量已上限,请联系客服',
      ManyPeople: '人数过多,请联系客服进行团购',
      ChangeReason: '改签原因不能为空',
      SeatNumbers: '乘客人数超过选择座位数',
      SelectSeat: '请为已选择的旅客选择座位'
    },
    succ: {
      SaveSucc: '保存成功！',
      CancelSucc: '取消成功！',
      ApprovalRefused: '审批拒绝！',
      ApproveSucc: '审批通过！',
      RefundSucc: '退票申请提交成功',
      ChangeSucc: '改签申请提交成功！',
      RegisteredSucc: '注册成功！',
      LoginSucc: '登陆成功！',
      ChangePasswordSucc: '密码修改成功',
      VerificationSucc: '验证码发送成功',
      AddSucc: '添加成功',
      ModifySucc: '修改成功',
      DeleteSucc: '删除成功',
      WeChat: '微信解绑成功'
    },
    confirm: {
      YesOrNoDelect: '是否确认删除',
      CreateOrder: '订单创建成功，欢迎您随时在订单详细中关注订单进度',
      ThankRemarks: '感谢您长期以来对力程商旅的信任与支持，为了更好提升用户差旅体验，力程商旅2018年10月30日上午9点起正式上线力程商旅2.0系统。用户可通过App Store自动更新, 安卓系统请联系本公司客服咨询，紧急联络电话15901610043。谢谢！'
    },
    loading: {
      load: '努力加载中',
      creatOrder: '订单创建中',
      PriceCalculation: '价格计算中'
    },
  },
  Categorys: {
    Young: '成人',
    Enfant: '儿童',
    Infant: '婴儿',
    economyClass: '经济舱',
    buissenesClass: '商务舱',
    firstClass: '头等舱',
    OnBusiness: '因公',
    OnPersonal: '因私',
    FlightService: '机票',
    HotelService: '酒店',
    TourService: '旅游',
    TrainService: '火车',
    SingleVoyage: '单程',
    RoundVoyage: '往返',
    WaitBooking: '待预订',
    WaitConfirm: '待确认',
    WaitPayment: '待支付',
    WaitDispose: '待处理',
    Finished: '已完成',
    Canceled: '已取消',
    Rejected: '已退回',
    Cannot: '暂不能',
    WaitApprove: '待审批',
    Discrete: '已拆分',
    WaitSubmit: '待提交',
    WaitRefund: '待退款',
    Male: '男',
    Female: '女',
    IDCard: "身份证",
    PassportCard: "护照",
    StudentCard: "学生证",
    OfficerCard: "军人证",
    HKMpermit: "回乡证",
    TaiWpermit: "台胞证",
	  HKCompatriotsyndrome: "港澳通行证",
	  TaiCompatriotsyndrome: "台湾通行证",
    OtherCard: "其它",
    Company: '公司',
    User: '用户',
    HotelFare: '房费',
    TicketFare: '票面',
    MobileAuth: '手机账号',
    EmailAuth: '邮箱账号',
    AccountAuth: '账号密码',
    WeixinAuth: '微信授权',
    DynamicAuth: '动态密码',
    MessageNotify: '短信通知',
    MailNotify: '邮件通知',
    WechatNotify: '微信通知',
    AppNotify: 'App通知',
    Normal: '普通',
    OverseasStudent: '学生',
    Worker: '劳务',
    Immigrant: '新移民',
    '1138Categorys': '身份证',
    '1139Categorys': '护照',
    '1140Categorys': '学生证',
    '1141Categorys': '军人证',
    '1298Categorys': '回乡证',
    '1299Categorys': '台胞证',
    '1233Categorys': '台湾通行证',
    '1234Categorys': '港澳通行证',
    // '1142Categorys': '其它',

    AmendingFlight: '部分退票中',
    ChangeingFlight: '部分改签中',
    AmendingTrain: '部分退票中',
    ChangeingTrain: '部分改签中',
    AmendingHotel: '部分退房中',
    ChangeingHotel: '部分改签中',
    AmendingTour: '部分退团中',
    ChangeingTour: '部分改签中',
    AmendedFlight: '部分退票',
    ChangeedFlight: '部分改签',
    AmendedTrain: '部分退票',
    ChangeedTrain: '部分改签',
    AmendedHotel: '部分退房',
    ChangeedHotel: '部分改签',
    AmendedTour: '部分退团',
    ChangeedTour: '部分改签',
    AllAmendingFlight: '退票中',
    AllChangeingFlight: '改签中',
    AllBookingFlight: '购票中',
    AllAmendingTrain: '退票中',
    AllChangeingTrain: '改签中',
    AllBookingTrain: '购票中',
    AllAmendingHotel: '退房中',
    AllChangeingHotel: '改签中',
    AllBookingHotel: '预订中',
    AllAmendingTour: '退团中',
    AllChangeingTour: '改签中',
    AllBookingTour: '预订中',
    AllAmendedFlight: '退票成功',
    AllChangeedFlight: '改签成功',
    AllBookedFlight: '购票成功',
    AllAmendedTrain: '退票成功',
    AllChangeedTrain: '改签成功',
    AllBookedTrain: '购票成功',
    AllAmendedHotel: '退房成功',
    AllChangeedHotel: '改签成功',
    AllBookedHotel: '预订成功',
    AllAmendedTour: '退团成功',
    AllChangeedTour: '改签成功',
    AllBookedTour: '预订成功',


  },
  RegExp: {
    AccountReg: {
      isEmpty: '账户不能空',
      isFormat: '账户格式不正确'
    },
    PwdReg: {
      isEmpty: '密码不能空',
      isFormat: '密码格式不正确'
    },
    ConfigPwd: {
      isEmpty: '密码不能空',
      isFormat: '密码不一致'
    },
    VerificationCodeReg: {
      isEmpty: '验证码不能空',
    },
    DynamicCodeReg: {
      isEmpty: '动态码不能空',
    },
    ProtocolReg: {
      isFlag: '必须遵守协议'
    }
  }
}
